import HttpService from './baseHttp'

//账户充值
export const HttpSaveRecharge = (data = {}) =>HttpService.post("/api/v2/funding/rechargeRecord/save",data,{ baseURL: process.env.VUE_APP_APIURL_FBB});

// 账户充值记录查询
export const HttpQueryAccount = (data = {}) =>HttpService.get("/api/v2/funding/rechargeRecord/query",{params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

// 资金记录查询
export const HttpQueryFreeze = (data = {}) =>HttpService.get("/api/v2/funding/freeze/query",{params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

// 资金冻结弹框
export const HttpSaveFreeze = (data = {}) =>HttpService.post("/api/v2/funding/freeze/save",data,{ baseURL: process.env.VUE_APP_APIURL_FBB});
// 资金解冻
export const HttpSaveUnfreeze= (data = {}) =>HttpService.post("/api/v2/funding/freeze/unFreeze",data,{ baseURL: process.env.VUE_APP_APIURL_FBB});

// 获取某个组织下的剩余额度
export const HttpGetAccountAmount = (data = {}) =>HttpService.get("/api/v2/funding/accountAmount/queryByOrgId",{params: data, baseURL: process.env.VUE_APP_APIURL_FBB});



